<template>
  <div class="row">
    <!--  数据源列表  -->
    <div class="flex xs12">
      <va-card title="数据源列表">
        <div class="row align--center mb-1">
          <div class="flex md6 xs12 sm6">
            <va-input class="ma-0" :value="url" placeholder="搜索数据源URL" @input="searchUrl" removable>
              <va-icon name="fa fa-search" slot="prepend" />
            </va-input>
          </div>
          <div class="flex md6 xs12 sm6">
            <va-input class="ma-0" :value="keyword" placeholder="搜索关键词（数据源名称/公司名称）" @input="searchKeyword" removable>
              <va-icon name="fa fa-search" slot="prepend" />
            </va-input>
          </div>
          <div class="flex md4 xs12 sm6">
            <va-select class="ma-0" v-model="crawlStatusFilter" label="爬取状态" :options="crawlStatusOptions" @input="listDataSource(1)" clearable />
          </div>
          <div class="flex md4 xs12 sm6">
            <va-select class="ma-0" v-model="siteCategoryFilter" label="网站分类" :options="siteCategoryOptions" @input="listDataSource(1)" clearable />
          </div>
          <div class="flex md4 xs12 sm6">
            <va-select class="ma-0" v-model="createdByFilter" label="爬虫项目" :options="createdByOptions" @input="listDataSource(1)" clearable />
          </div>
          <div class="flex md12 xs12">
            <va-button class="mb-2" flat disabled color="danger">总计{{ totalCount }}条结果</va-button>
          </div>
        </div>
        <va-data-table :fields="fields" :data="dataSources" :loading="loading" :totalPages="totalPages"
          @page-selected="listDataSource" api-mode>
          <template slot="siteCategory" slot-scope="props">
            <va-badge :color="computeSiteCategoryColor(props.rowData.siteCategory)">
              {{ computeSiteCategoryText(props.rowData.siteCategory) }}
            </va-badge>
          </template>

          <template slot="crawlStatus" slot-scope="props">
            <va-badge :color="computeCrawlStatusColor(props.rowData.crawlStatus)">
              {{ computeCrawlStatusText(props.rowData.crawlStatus) }}
            </va-badge>
          </template>

          <template slot="updateTime" slot-scope="props">
            {{ formatTime(props.rowData.updateTime) }}
          </template>

          <template slot="actions" slot-scope="props">
            <va-popover message="查看详情" placement="top">
              <va-button flat small color="info" icon="fa fa-eye"
                @click="$router.push(`/admin/referrals/dataSourceDetail/${props.rowData.id}`)" />
            </va-popover>
          </template>
        </va-data-table>
      </va-card>
    </div>
  </div>
</template>

<script>
import debounce from 'lodash/debounce'
import dataSourceApi from '../../api/dataSource'

export default {
  data() {
    return {
      dataSources: [],
      url: '',
      keyword: '',
      crawlStatusFilter: '',
      siteCategoryFilter: '',
      createdByFilter: '',
      crawlStatusOptions: ['未爬取', '成功', '本轮无岗位', '失败', '已调度', '爬取中', '解析中'],
      siteCategoryOptions: ['ATS系统', '公司招聘页', '聚合网站'],
      createdByOptions: ['Shell-脚本爬虫', '微服务爬虫', 'unknown', 'ai'],
      loading: true,
      totalCount: 0,
      pageNumber: 1,
      pageSize: 20,
      totalPages: 1,
    }
  },
  computed: {
    fields() {
      return [
        {
          name: 'name',
          title: '数据源名称',
          width: '15%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: 'organizationName',
          title: '公司名称',
          width: '15%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: '__slot:siteCategory',
          title: '网站分类',
          width: '10%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: 'createdBy',
          title: '爬虫项目',
          width: '15%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: '__slot:crawlStatus',
          title: '爬取状态',
          width: '10%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: '__slot:updateTime',
          title: '更新时间',
          width: '15%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: '__slot:actions',
          title: '操作',
          width: '10%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
      ]
    },
  },
  created() {
    this.listDataSource()
  },
  methods: {
    listDataSource(pageNumber = this.pageNumber) {
      this.loading = true
      const params = {
        url: this.url,
        keyword: this.keyword,
        pageNumber: pageNumber,
        pageSize: this.pageSize,
      }
      if (this.crawlStatusFilter) {
        const crawlStatusMap = { '未爬取': 0, '成功': 1, '本轮无岗位': 2, '失败': 3, '已调度': 10, '爬取中': 20, '解析中': 30 }
        params.crawlStatus = crawlStatusMap[this.crawlStatusFilter]
      }
      if (this.siteCategoryFilter) {
        const siteCategoryMap = { 'ATS系统': 1, '公司招聘页': 2, '聚合网站': 3 }
        params.siteCategory = siteCategoryMap[this.siteCategoryFilter]
      }
      if (this.createdByFilter) {
        params.createdBy = this.createdByFilter
      }
      dataSourceApi.listDataSource(params).then(response => {
        this.dataSources = response.dataSourceList || []
        this.totalCount = response.pages.totalCount || 0
        this.totalPages = response.pages.totalPage || 1
        this.pageNumber = pageNumber
        this.loading = false
      }).catch(error => {
        this.showToast(error.msg || '获取数据源列表失败', {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
        this.loading = false
      })
    },
    searchUrl: debounce(function (url) {
      this.url = url
      this.listDataSource(1)
    }, 400),
    searchKeyword: debounce(function (keyword) {
      this.keyword = keyword
      this.listDataSource(1)
    }, 400),
    formatTime(time) {
      if (!time) return '-'
      // 如果是10位时间戳（秒级），转换成毫秒级
      const timestamp = time.toString().length === 10 ? time * 1000 : time
      return new Date(timestamp).toLocaleString('zh-CN')
    },
    computeSiteCategoryText(category) {
      const map = {
        1: 'ATS系统',
        2: '公司招聘页',
        3: '聚合网站',
      }
      return map[category] || '未知'
    },
    computeSiteCategoryColor(category) {
      const colorMap = {
        1: 'warning',
        2: 'info',
        3: 'success',
      }
      return colorMap[category] || 'gray'
    },
    computeCrawlStatusText(status) {
      const map = {
        0: '未爬取',
        10: '已调度',
        20: '爬取中',
        30: '解析中',
        1: '成功',
        2: '本轮无岗位',
        3: '失败',
      }
      return map[status] || '未知'
    },
    computeCrawlStatusColor(status) {
      const colorMap = {
        0: 'gray',
        10: 'info',
        20: '#F57C00',
        30: 'primary',
        1: 'success',
        2: '#795548',
        3: 'danger',
      }
      return colorMap[status] || 'gray'
    },
  },
}
</script>
